import { types, Actions } from './action';

export interface IOrgNameState{
    orgName:string
}
const initialState:IOrgNameState = {
  orgName: '',
};

const reducer = (state = initialState, action: Actions) => {
  switch (action.type) {
    case types.SET_ORGNAME:
      return {
        ...state,
        orgName: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
